// src/hooks/useClickOutside.js
import { useEffect } from "react";

function useClickOutside(filters, callback) {
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click target is contained within ANY of the filter elements.
      // If 'isInsideAnyFilter' is true, it means the click was inside one of the monitored elements.
      const isInsideAnyFilter = filters.some(
        (filterRef) =>
          filterRef.current && filterRef.current.contains(event.target)
      );

      // If the click was NOT inside any of the filter elements, execute the callback.
      if (!isInsideAnyFilter) {
        callback();
      }
    };

    // Attach the event listener to the document
    // Using 'mousedown' is often preferred over 'click' for outside-click detection
    // because it fires earlier in the event lifecycle, potentially avoiding issues
    // where 'click' might be prevented by other elements.
    document.addEventListener("mousedown", handleClickOutside); // Changed to mousedown

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside); // Changed to mousedown
    };
  }, [filters, callback]); // Re-run effect if 'filters' array or 'callback' changes
}

export default useClickOutside;
